module.exports = __webpack_public_path__ + "static/media/benefits_sync_illustration@2x.a372e897.png";